export const GIVING_DAY_DISPLAY_CUTOFF = Temporal.ZonedDateTime.from(
  "2026-06-23T23:59:00[America/Denver]",
);

/** True when `now` is before the 11:59 PM Mountain cutoff on June 23, 2026. */
export function isBeforeGivingDayCutoff(now: Temporal.Instant): boolean {
  return (
    Temporal.Instant.compare(now, GIVING_DAY_DISPLAY_CUTOFF.toInstant()) < 0
  );
}
